export class Energy {
  constructor(amount) {
    this._amount = amount;
  }

  set amount(amount) {
    this._amount = amount;
  }

  get amount() {
    return this._amount;
  }

  toJSON() {
    return {
      amount: this.amount,
    };
  }
}
